import type { CSSProperties } from 'react'
import type { useTheme } from '../hooks/useTheme'

type Theme = ReturnType<typeof useTheme>

/**
 * Common style utilities that use theme values
 * Use these instead of inline theme.isDark conditionals
 */

export const INPUT_CLASS_NAME =
  'w-full rounded-xl px-4 py-3 text-base outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed'

export const TEXTAREA_CLASS_NAME = `${INPUT_CLASS_NAME} resize-none`

export function getInputStyle(theme: Theme): CSSProperties {
  return {
    backgroundColor: theme.inputBg,
    color: theme.text.primary,
    border: `1px solid ${theme.inputBorder}`,
  }
}

export function getFormErrorStyle(): CSSProperties {
  return {
    backgroundColor: 'rgba(239,68,68,0.08)',
    border: '1px solid rgba(239,68,68,0.25)',
  }
}

export function getInfoBannerStyle(theme: Theme): CSSProperties {
  return {
    backgroundColor: `${theme.buttonColor}10`,
    border: `1px solid ${theme.buttonColor}25`,
  }
}

export function getSectionCardStyle(theme: Theme): CSSProperties {
  return {
    backgroundColor: theme.cardBg,
    border: `1px solid ${theme.cardBorder}`,
  }
}

export function getBrandBg(theme: Theme, opacity: 'light' | 'medium' | 'dark' = 'medium') {
  return theme.brand[opacity]
}

export function getBrandText(theme: Theme) {
  return theme.brand.solid
}

export function getCardShadow(theme: Theme) {
  return theme.shadow.card
}

export function getOverlapBadgeStyle(theme: Theme) {
  return {
    backgroundColor: theme.accent.medium,
    color: theme.accent.text,
  }
}

export function getOverlapContainerStyle(theme: Theme) {
  return {
    backgroundColor: theme.isDark ? 'rgba(0, 136, 204, 0.08)' : 'rgba(0, 136, 204, 0.05)',
    border: `2px solid ${theme.accent.border}`,
  }
}
